"use strict";
var isObject = require('./isObject');
function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;
//# sourceMappingURL=_isStrictComparable.js.map